<table class="grey">
  <thead>
  <tr class="headnote">
    <td i18n class="strong">Lp.</td>
    <td i18n class="strong">Nazwa</td>
    <td i18n class="strong">Początek</td>
    <td i18n class="strong">Koniec</td>
    <td i18n class="strong">Limit żetonów</td>
    <td i18n class="strong">Atrybuty</td>
  </tr>
  </thead>
  <tbody class="autostrong">
  <tr *ngFor="let round of registration.rounds; let i = index" [ngClass]="{'upcoming': round.id === registration.upcomingRound()?.id}">
    <td class="strong">{{i + 1}}</td>
    <td class="strong">{{round.name}}</td>
    <td class="strong">{{round.dateFrom | date:'short'}}</td>
    <td class="strong">{{round.dateTo | date:'short'}}</td>
    <td  class="strong">
      <ng-container *ngFor="let t of round.tokens">
        {{t.count}} × {{t.tokenTypeId}}
      </ng-container>
    </td>
    <td class="strong">
      <img *ngIf="round.isExchange" alt='Tura z giełdą' i18n-alt src="img/gielda1.gif"
      matTooltip="Tura z giełdą" i18n-matTooltip
      >
      <img *ngIf="round.isDedicated" alt="Tura przeznaczona dla grup dedykowanych" i18n-alt src="img/dedykowana1.gif"
      matTooltip="Tura przeznaczona dla grup dedykowanych" i18n-matTooltip>
      <img *ngIf="round.isOnlyEntitled" alt="Tylko dla uprawnionych" i18n-alt src="img/zazn.gif"
           matTooltip="Tylko dla uprawnionych" i18n-matTooltip
      >
    </td>
  </tr>
  <tr *ngIf="registration.rounds.length === 0">
    <td colspan="6" i18n class="disclaimer">Nie zdefiniowano jeszcze tur rejestracji</td>
  </tr>
  </tbody>
</table>
